/**
 * Starter stub — replace with real institute settings when needed.
 */
export async function fetchInstituteSettings(_organizationId) {
  return { data: { summary_cards_enabled: true } };
}

export async function saveInstituteSettings(_payload) {
  return { success: true };
}
